import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translations, styles } from 'gipsy-misc';
import { HeaderContainer, Title, Star, Separator } from './Common';
import ReviewFields from './ReviewFields';
import ReviewersStatus from './ReviewersStatus';

var ReviewedReviewAsReviewer = function (_PureComponent) {
  _inherits(ReviewedReviewAsReviewer, _PureComponent);

  function ReviewedReviewAsReviewer() {
    _classCallCheck(this, ReviewedReviewAsReviewer);

    return _possibleConstructorReturn(this, (ReviewedReviewAsReviewer.__proto__ || Object.getPrototypeOf(ReviewedReviewAsReviewer)).apply(this, arguments));
  }

  _createClass(ReviewedReviewAsReviewer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          review = _props.review,
          reviewers = _props.reviewers,
          onChange = _props.onChange;


      return React.createElement(
        HeaderContainer,
        { backgroundColor: 'white' },
        React.createElement(
          Title,
          null,
          React.createElement(Star, { icon: 'Star', fill: styles.colors.textDarkColor, size: 16 }),
          React.createElement(
            'div',
            null,
            translations.review.header.reviewedReviewAsReviewer.title
          )
        ),
        React.createElement(ReviewFields, { onChange: onChange, review: review }),
        React.createElement(Separator, null),
        React.createElement(ReviewersStatus, { reviewers: reviewers })
      );
    }
  }]);

  return ReviewedReviewAsReviewer;
}(PureComponent);

ReviewedReviewAsReviewer.propTypes = {
  review: PropTypes.object,
  reviewers: PropTypes.array,
  onChange: PropTypes.func.isRequired
};


export default ReviewedReviewAsReviewer;
//# sourceMappingURL=ReviewedReviewAsReviewer.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/Header/Review/ReviewedReviewAsReviewer.js
// module id = 1116
// module chunks = 0